import { c as _c } from "react/compiler-runtime";
import { Button, Skeleton } from '@common/components';
import { useToast } from '@common/hooks';
import { cn } from '@core/utils';
import { useState } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import type { EventType } from '@/app/donation/types';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { DonationCertificateDialog } from '../../_components/DonationCertificateDialog';

// 공통 필드 타입
interface BaseDonationListItemProps {
  donationBusinessName?: string;
  donationBusinessId?: number;
  donationBusinessThumbnailUrl?: string;
  eventType?: EventType;
  eventRewardProductNameList?: string[];
  onBusinessClick?: () => void;
  isCancelled?: boolean;
}

// loading이 true일 때의 타입
interface LoadingDonationListItemProps extends BaseDonationListItemProps {
  loading: true;
  institutionLogoUrl?: string;
  institutionName?: string;
  epayNumber?: string;
  donationAmount?: number;
  paidAt?: string;
}

// loading이 false 또는 undefined일 때의 타입
interface LoadedDonationListItemProps extends BaseDonationListItemProps {
  loading?: false;
  institutionLogoUrl: string;
  institutionName: string;
  epayNumber: string;
  donationAmount: number;
  paidAt: string;
}
type DonationListItemProps = LoadingDonationListItemProps | LoadedDonationListItemProps;
export const DonationListItem = t0 => {
  const $ = _c(48);
  const {
    institutionLogoUrl,
    institutionName,
    donationBusinessThumbnailUrl,
    epayNumber,
    donationBusinessName,
    donationBusinessId,
    donationAmount,
    paidAt,
    loading,
    onBusinessClick,
    eventRewardProductNameList,
    isCancelled
  } = t0;
  const {
    toast
  } = useToast();
  const [selectedCertificateNumber, setSelectedCertificateNumber] = useState(null);
  const isDisplayEventPrizeArea = eventRewardProductNameList && eventRewardProductNameList.length > 0;
  let t1;
  if ($[0] !== epayNumber || $[1] !== toast) {
    t1 = () => {
      if (epayNumber) {
        setSelectedCertificateNumber(epayNumber);
      } else {
        toast({
          type: "fail",
          message: "\uAE30\uBD80\uC99D\uC11C\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."
        });
      }
    };
    $[0] = epayNumber;
    $[1] = toast;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleCertificateClick = t1;
  if (loading) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="flex w-full items-center justify-between"><div className="flex items-center gap-4"><div className="relative shrink-0 overflow-hidden rounded-pill border border-Gray-300"><Skeleton className="size-20 rounded-xsmall" /></div><Skeleton className="h-19 w-100 rounded-xsmall" /></div><Skeleton className="h-19 w-100 rounded-xsmall" /></div>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Skeleton className="h-19 w-200 rounded-xsmall" />;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <li className="flex flex-col items-center gap-20 rounded-medium border border-Gray-200 bg-Gray-white p-20">{t2}<div className="flex flex-col items-center gap-8">{t3}<div className="flex items-center gap-8"><Skeleton className="h-16 w-55 rounded-xsmall" /><Skeleton className="h-16 w-70 rounded-xsmall" /></div></div><Skeleton className="h-40 w-full rounded-xsmall" /></li>;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  let t2;
  if ($[6] !== institutionName || $[7] !== paidAt) {
    t2 = <Header institutionName={institutionName} paidAt={paidAt} className="mb-12" />;
    $[6] = institutionName;
    $[7] = paidAt;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("flex justify-between gap-16", "mobile-tablet:flex-col");
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== donationBusinessId || $[11] !== donationBusinessName || $[12] !== donationBusinessThumbnailUrl || $[13] !== institutionLogoUrl || $[14] !== institutionName || $[15] !== onBusinessClick) {
    t4 = donationBusinessId && donationBusinessThumbnailUrl ? <BusinessImageLink donationBusinessId={donationBusinessId} donationBusinessName={donationBusinessName || ""} donationBusinessThumbnailUrl={donationBusinessThumbnailUrl} onBusinessClick={onBusinessClick} /> : <InstitutionImage institutionLogoUrl={institutionLogoUrl} institutionName={institutionName} />;
    $[10] = donationBusinessId;
    $[11] = donationBusinessName;
    $[12] = donationBusinessThumbnailUrl;
    $[13] = institutionLogoUrl;
    $[14] = institutionName;
    $[15] = onBusinessClick;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== donationBusinessId || $[18] !== donationBusinessName || $[19] !== onBusinessClick) {
    t5 = donationBusinessId && donationBusinessName ? <CustomLink href={DONATION_ROUTES.HOMETOWN_BUSINESS_DETAIL.pathname({
      id: donationBusinessId
    })} className={cn("line-clamp-1 font-500 text-Gray-900 typo-body3", "mobile-tablet:typo-body4")} onClick={onBusinessClick}>{donationBusinessName}</CustomLink> : null;
    $[17] = donationBusinessId;
    $[18] = donationBusinessName;
    $[19] = onBusinessClick;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== donationAmount || $[22] !== isCancelled) {
    t6 = isCancelled ? <p className="font-700 text-Gray-550 typo-body3">기부가 취소되었습니다</p> : <div className="flex items-center gap-8"><p className="font-700 text-Gray-550 typo-body3">기부금액</p><p className="font-700 text-Gray-900 typo-body3">{donationAmount?.toLocaleString()} 원</p></div>;
    $[21] = donationAmount;
    $[22] = isCancelled;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t5 || $[25] !== t6) {
    t7 = <div className="flex flex-col gap-2">{t5}{t6}</div>;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== t4 || $[28] !== t7) {
    t8 = <div className="flex items-center gap-12">{t4}{t7}</div>;
    $[27] = t4;
    $[28] = t7;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== handleCertificateClick || $[31] !== isCancelled) {
    t9 = !isCancelled ? <div className="flex min-w-138 items-center gap-10"><Button theme="sub-line" dimensions="H40" className={cn("mobile-tablet:flex-1", "basis-[138px]")} onClick={handleCertificateClick}>기부증서</Button></div> : null;
    $[30] = handleCertificateClick;
    $[31] = isCancelled;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== t8 || $[34] !== t9) {
    t10 = <div className={t3}>{t8}{t9}</div>;
    $[33] = t8;
    $[34] = t9;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== eventRewardProductNameList || $[37] !== isDisplayEventPrizeArea) {
    t11 = isDisplayEventPrizeArea ? <div className="mt-12 flex w-full flex-col gap-8 rounded-small bg-Gray-25 px-16 py-12"><div className="flex items-center gap-2"><p className="font-600 text-Gray-600 typo-caption1">이벤트 당첨내역</p></div><p className="whitespace-pre-line font-500 text-Gray-900 typo-body4">{eventRewardProductNameList.join("\n\n")}</p></div> : null;
    $[36] = eventRewardProductNameList;
    $[37] = isDisplayEventPrizeArea;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== t10 || $[40] !== t11 || $[41] !== t2) {
    t12 = <li className="flex flex-col rounded-medium border border-Gray-200 bg-Gray-white p-20">{t2}{t10}{t11}</li>;
    $[39] = t10;
    $[40] = t11;
    $[41] = t2;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  let t13;
  if ($[43] !== selectedCertificateNumber) {
    t13 = selectedCertificateNumber ? <DonationCertificateDialog opened={!!selectedCertificateNumber} epayNumber={selectedCertificateNumber} onClose={() => setSelectedCertificateNumber(null)} /> : null;
    $[43] = selectedCertificateNumber;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] !== t12 || $[46] !== t13) {
    t14 = <>{t12}{t13}</>;
    $[45] = t12;
    $[46] = t13;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  return t14;
};
interface HeaderProps {
  institutionName: string;
  paidAt: string;
  className?: string;
}
const Header = t0 => {
  const $ = _c(12);
  const {
    institutionName,
    paidAt,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex w-full items-center justify-between", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("line-clamp-1 font-600 text-Gray-600 typo-body4", "mobile-tablet:typo-caption1");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== institutionName) {
    t3 = <div className="flex items-center justify-between gap-4"><p className={t2}>{institutionName}</p></div>;
    $[3] = institutionName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("font-400 text-Gray-550 typo-body4", "mobile-tablet:typo-caption1");
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== paidAt) {
    t5 = <p className={t4}>{paidAt}</p>;
    $[6] = paidAt;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t5) {
    t6 = <div className={t1}>{t3}{t5}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
const BusinessImageLink = t0 => {
  const $ = _c(10);
  const {
    donationBusinessId,
    donationBusinessName,
    donationBusinessThumbnailUrl,
    onBusinessClick
  } = t0;
  let t1;
  if ($[0] !== donationBusinessId) {
    t1 = DONATION_ROUTES.HOMETOWN_BUSINESS_DETAIL.pathname({
      id: donationBusinessId
    });
    $[0] = donationBusinessId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("relative size-72 shrink-0 overflow-hidden rounded-small border border-Gray-black/5", "mobile-tablet:size-52");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== donationBusinessName || $[4] !== donationBusinessThumbnailUrl) {
    t3 = <Image src={donationBusinessThumbnailUrl} alt={donationBusinessName} fill={true} className="object-cover" sizes={`${BREAKPOINTS.MOBILE_TABLET} 52px, 72px`} />;
    $[3] = donationBusinessName;
    $[4] = donationBusinessThumbnailUrl;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onBusinessClick || $[7] !== t1 || $[8] !== t3) {
    t4 = <CustomLink href={t1} onClick={onBusinessClick} className={t2}>{t3}</CustomLink>;
    $[6] = onBusinessClick;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
const InstitutionImage = t0 => {
  const $ = _c(4);
  const {
    institutionLogoUrl,
    institutionName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("relative size-72 shrink-0 overflow-hidden rounded-small border border-Gray-black/5", "mobile-tablet:size-52");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = institutionLogoUrl || "";
  const t3 = `${institutionName || "\uC9C0\uC790\uCCB4"} 로고`;
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = <div className={t1}><Image src={t2} alt={t3} fill={true} className="object-cover" sizes={`${BREAKPOINTS.MOBILE_TABLET} 52px, 72px`} /></div>;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};